import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { useCreateProjectIndication } from 'lib/hooks/project/useCreateProjectIndication';
import React from 'react';
import styled from 'styled-components';
import IndicationCard, { IIndicationCard } from './IndicationCard';
import { IIndicationData } from 'lib/types/clinic/projectTypes';

interface ProjectIndicationTypeProps {
  isTypeMore: boolean;
  indicationPartList: (IIndicationCard | undefined)[][] | undefined;
  indicationIdx: string;
  onMoreChange: () => void;
  onIndicationChange: (index: string, data?: IIndicationData, isPhotogrammetry?: boolean) => void;
}

const ProjectIndicationType = ({
  isTypeMore,
  indicationPartList,
  indicationIdx,
  onMoreChange,
  onIndicationChange,
}: ProjectIndicationTypeProps) => {
  return (
    <StyledProjectIndicationType>
      {indicationPartList?.map((partList, index) => {
        return (
          <div className="projectIndicationType__container" key={index}>
            {partList?.map((part?: IIndicationCard) => {
              if (!part) return;
              return (
                <IndicationCard
                  key={part.key}
                  selectedKey={indicationIdx}
                  cardItem={part}
                  onClick={onIndicationChange}
                />
              );
            })}
          </div>
        );
      })}
      <StyledMoreButton onClick={onMoreChange}>
        <CustomText fontSize={18} fontColor="#00a6e2" fontWeight={600}>
          {isTypeMore ? <T>GLOBAL_VIEW_REDUCTION</T> : <T>GLOBAL_VIEW_MORE</T>}
        </CustomText>
      </StyledMoreButton>
    </StyledProjectIndicationType>
  );
};

const StyledProjectIndicationType = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  overflow: auto;
  .projectIndicationType__container {
    display: flex;
    flex-wrap: wrap;
  }
`;

const StyledMoreButton = styled.button`
  width: 70px;
  text-align: left;
`;

export default ProjectIndicationType;
